import {Component, Input} from "@angular/core";
import {AvdbRegion} from "../avdb-region";
import {AvdbPricingProduct} from "../database-pricing/avdb-pricing-product";
import {AvdbPricingProductCoverageDuration} from "../database-pricing/avdb-pricing-product-coverage-duration";
import {AvdbPricingProductRegion} from "../database-pricing/avdb-pricing-product-region";
import {cdnURL} from "site";

@Component({
	selector: "coverage-detail",
	template: `
		<modal *ngIf="coverageRegion !== null" (close)="unsetCoverage()">
			<header class="modal_header">
				<h2>Coverage Details</h2>
			</header>
			<div class="modal_body">
				<h3 class="coveragedetail_seriesinfo">
					{{coverageRegion.name}} <span *ngIf="coverageRegion.vendorName" class="coveragedetail_seriesinfo_vendor">by {{coverageRegion.vendorName}}</span>
				</h3>
				<div *ngIf="coverageDurationOptions !== null && coverageProduct !== null">
					<p class="coveragedetail_productdetails">Part number: {{coverageProduct.partKey}}</p>
					<p class="coveragedetail_productdetails">Duration: {{coverageDuration}}</p>
				</div>
				<image-container [width]="420" [height]="350" [src]="coverageMapPath + coverageRegion.coverageMapFilename" [alt]="'Coverage Map'"></image-container>
				<div class="coveragedetail_coveragetext" [innerHtml]="coverageRegion.coverageDescriptionHTML"></div>
			</div>
		</modal>
	`,
})
export class CoverageDetailComponent {
	coverageRegion: AvdbPricingProductRegion | AvdbRegion = null;
	coverageDurationOptions: Array<AvdbPricingProductCoverageDuration> = null;
	coverageProduct: AvdbPricingProduct = null;
	coverageDuration: string = '';

	@Input()
	coverageMapPath = cdnURL + "/img/avdb_type_regions/";

	open(productRegion: AvdbPricingProductRegion | AvdbRegion, coverageDurationOptions: Array<AvdbPricingProductCoverageDuration> = null, product: AvdbPricingProduct = null) {
		this.coverageRegion = productRegion;
		this.coverageDurationOptions = coverageDurationOptions;
		this.coverageProduct = product;
		this.coverageDuration = (this.coverageProduct == null) ? '' : product.subscriptionDuration;
	}

	unsetCoverage() {
		this.coverageRegion = null;
		this.coverageDurationOptions = null;
		this.coverageProduct = null;
	}
}
